<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'
import { deleteHistoryKey } from '~/utils/localStorage'

const { getNuxtLink, isExternal } = useCustomLink()
// props
const props = defineProps({
  historyData: {
    type: Array,
    default: () => []
  }
})

const showHistoryData = ref([])

if (props.historyData.length > 0) {
  const historyLatLonArray = props.historyData.map((item) => {
    return `${item?.lat}:${item?.lon}`
  })
  const historyLatLonKey = historyLatLonArray.join('/')
  const response = await fetch(`/clothes/api/clothes/history?latlons=${encodeURIComponent(historyLatLonKey)}`) // 通常の fetch なので URL構造に注意
  const historyClothesData = await response.json()

  // merge historyData and historyClothesData
  showHistoryData.value = props.historyData.map((item) => {
    const latLonKey = `${item?.lat}:${item?.lon}`
    const historyClothesItem = historyClothesData[latLonKey]
    return {
      ...item,
      contents: historyClothesItem
    }
  })
}

const deleteHistory = function (historyKey) {
  if (!historyKey) {
    return
  }
  deleteHistoryKey(historyKey)
  showHistoryData.value = showHistoryData.value.filter((item) => {
    return item?.historyKey !== historyKey
  })
}
</script>

<template>
  <ClientOnly>
    <section
      v-if="showHistoryData.length > 0"
      class="clothesLog"
    >
      <SectionTitle title="閲覧履歴" />
      <div class="inner">
        <div
          v-for="log in showHistoryData"
          :key="log.historyKey"
          class="log"
        >
          <div class="heading">
            <div class="headLeft">
              <p class="area">
                {{ log.historyKey }}
              </p>
              <button
                type="button"
                class="delete"
                @click="deleteHistory(log.historyKey)"
              >
                <img
                  src="https://gvs.weathernews.jp/clothes/images/icon/icon_close_blue_circle.svg"
                  alt="履歴を削除"
                  width="20"
                  height="20"
                  loading="lazy"
                >
              </button>
            </div>
            <NuxtLink
              v-if="log.link"
              :external="isExternal(log.link)"
              :to="getNuxtLink(log.link)"
              class="link"
            >
              服装予報の詳細へ
            </NuxtLink>
          </div>
          <div class="table">
            <div class="head">
              <div class="content">
                <p>昼間</p>
              </div>
              <div class="content">
                <p>朝晩</p>
              </div>
            </div>
            <div class="body">
              <div
                v-for="item in log.contents"
                :key="item.date"
                class="row"
              >
                <p
                  class="date"
                  :data-dow="item.dowEn"
                >
                  {{ item.date }}<span>{{ item.dowJp }}</span>
                </p>
                <div class="content">
                  <figure :data-tooltip="item.clothesDay.daytime.name">
                    <img
                      :src="item.clothesDay.daytime.icon"
                      :alt="item.clothesDay.daytime.name"
                      width="36"
                      height="31"
                      loading="lazy"
                    >
                  </figure>
                </div>
                <div class="content">
                  <figure :data-tooltip="item.clothesDay.morning_night.name">
                    <img
                      :src="item.clothesDay.morning_night.icon"
                      :alt="item.clothesDay.morning_night.name"
                      width="36"
                      height="31"
                      loading="lazy"
                    >
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.clothesLog {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .inner {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .log {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .headLeft {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .area {
    border-left: solid 5px #3569C0;
    padding-left: 5px;
    color: #303030;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
  }
  .delete {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .link {
    padding-right: 25px;
    background-image: url('https://gvs.weathernews.jp/clothes/images/icon/icon_arrow_blue_circle.svg');
    background-position: right center;
    background-repeat: no-repeat;
    background-size: 20px;
    color: #3569C0;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    text-decoration: underline;
  }
  .table {
    display: flex;
    .head {
      display: flex;
      flex-direction: column;
      width: 30px;
      padding-top: 20px;
    }
    .body {
      display: flex;
      flex: 1;
    }
    .row {
      flex: 1;
      &:nth-child(odd) {
        background-color: #F5F5F5;
        .date {
          border-bottom-color: #fff;
        }
      }
    }
    .date {
      padding: 3px;
      height: 20px;
      color: #000;
      text-align: center;
      font-size: 13px;
      font-weight: 600;
      line-height: 1em;
      border-bottom: solid 1px #f5f5f5;
      &[data-dow="sat"] {
        span {
          color: #6A6CC2;
        }
      }
      &[data-dow="sun"] {
        span {
          color: #E78142;
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3px;
      height: 42px;
      p {
        padding-top: 18px;
        color: #303030;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        line-height: 1em;
        background-position: center top;
        background-repeat: no-repeat;
        background-size: auto;
      }
      &:first-child {
        p {
          background-image: url('https://gvs.weathernews.jp/clothes/images/icon/icon_day.svg');
        }
      }
      &:last-child {
        p {
          background-image: url('https://gvs.weathernews.jp/clothes/images/icon/icon_night.svg');
        }
      }
      figure {
        height: 31px;
        img {
          width: auto;
          height: 100%;
        }
      }
    }
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
    .delete {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
    .content {
      figure {
        position: relative;
        &::after {
          position: absolute;
          bottom: 105%;
          left: 0;
          display: block;
          padding: 7px 8px 5px;
          background: #000;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 300;
          color: #fff;
          white-space: nowrap;
          content: attr(data-tooltip);
          opacity: 0;
          z-index: 10;
          transition: opacity .2s ease-in-out;
          pointer-events: none;
        }
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      }
    }
    .table {
      .row {
        &:nth-child(n + 5) {
          .content {
            figure {
              &::after {
                left: auto;
                right: 0;
              }
            }
          }
        }
      }
    }
  }
}
.main {
  .clothesLog {
    @media screen and (min-width: 830px) {
      .table {
        .head {
          width: 40px;
          padding-top: 28px;
        }
        .date {
          padding: 5px;
          height: 28px;
          font-size: 18px;
        }
        .content {
          padding: 5px;
          height: 50px;
          p {
            font-size: 15px;
          }
          figure {
            height: 40px;
          }
        }
      }
    }
  }
}
  </style>
